import "./BankingDetails.css";
import "react-datepicker/dist/react-datepicker.css";
import React, { useState, useEffect } from "react";
import { Card, CardBody, CardTitle, CardFooter } from "reactstrap";
import StripeLogo from "../../assets/images/stripe-logo.png";
import BankThumbnail from "../../assets/images/bankThumbnail.png";
import Loader from "../loader/loader";
import bankService from "../../api/services/bankService";
export function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}
const BankingDetails = () => {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );
  const [isLoading, setIsLoading] = useState();
  const [showLoginLink, setShowLoginLink] = useState("");
  const getStripeLoginLink = async () => {
    try {
      const resp = await bankService.getStripeLoginLink();
      if (resp && resp.success) {
        setShowLoginLink(resp.data.url);
      }
    } catch (error) {}
  };

  const onSubmit = async (account_type) => {
    setIsLoading(true);
    if (showLoginLink) {
      setIsLoading(false);
      window.open(showLoginLink, "_blank");
      return;
    }
    try {
      const respConnectStripLink = await bankService.connectStripeLink(
        "https://dashboard.stndaprt.com/#/payment-details",
        "https://dashboard.stndaprt.com/#/payment-details",
        account_type
      );
      setIsLoading(false);
      window.open(respConnectStripLink.data.url, "_blank");
    } catch (error) {}
  };

  useEffect(() => {
    // getBankDetails();
    getStripeLoginLink();
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Card>
      <CardTitle className="border-bottom p-3 mb-0 font-weight-bold text-uppercase">
        Payout Details
      </CardTitle>
      <CardBody>
        <div className="col-6 p-0">
          <div
            className=" pb-3 mb-0 "
            style={{ color: "#4463b4", fontSize: 24, fontWeight: "600" }}
          >
            Bank Account Information
          </div>
        </div>
        <p
          className="border-bottom"
          style={{
            color: "#858684",
            paddingBottom: "55px",
          }}
        >
          Stripe Connect is the core Stripe product for Marketplaces and
          Platforms like STND APRT.
          <br />
          It allows us to take a payment from a customer and split it between
          several other recipients.
          <br />
          Register your business or use your current Stripe account below to
          begin receiving payments.
        </p>
        <div
          onClick={() => {
            window
              .open(
                "https://www.youtube.com/watch?v=ynDX0wdhVDo&list=PLmis7uALvV_yqG16ihUzjTFdEKBqtEkR0&t=90",
                "_blank"
              )
              .focus();
          }}
          style={{
            position: "absolute",
            right: 32,
            top: 70,
            display: "flex",
            cursor: "pointer",
          }}
        >
          <div
            style={{
              fontSize: 14,
              lineHeight: 1.3,
              whiteSpace: "break-spaces",
              fontStyle: "italic",
              marginRight: 8,
              fontWeight: "bold",
              color: "#7460ee",
            }}
          >
            {"How to\nvideo"}
          </div>
          <img
            src={BankThumbnail}
            style={{
              height: 170,
              width: 314,
            }}
          />
        </div>

        <Loader isLoading={isLoading} />
        <div className="row" style={{ position: "relative" }}>
          <div
            className={windowDimensions.width < 1296 ? "col-5" : "col-6"}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: windowDimensions.width < 1125 ? "center" : "flex-end",
              paddingRight: windowDimensions.width < 1296 ? 8 : 100,
              marginTop: windowDimensions.width < 1420 ? 212 : 76,
              marginBottom: 160,
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <p
                className="mt-3 "
                style={{
                  color: "#000000",
                  fontSize: "36px",
                  fontWeight: 600,
                  lineHeight: "120%",
                  marginRight: 32,
                }}
              >
                STND APRT <br /> partners with <br />
                Stripe for secure
                <br /> payments
              </p>
              <img
                src={StripeLogo}
                style={{
                  height: 50,
                  width: 330,
                  marginTop: 28,
                  marginLeft: -4,
                }}
              />
            </div>
          </div>
          <div
            className={windowDimensions.width < 1296 ? "col-7" : "col-6"}
            style={{
              display: "flex",
              flexDirection: "column",
              marginTop: windowDimensions.width < 1420 ? 212 : 76,
            }}
          >
            <p
              className="mt-3 "
              style={{
                color: "#000000",
                fontSize: "36px",
                fontWeight: 600,
                lineHeight: "120%",
                marginRight: 32,
              }}
            >
              Get started with Stripe
            </p>
            <p
              style={{
                color: "#858684",
                paddingBottom: windowDimensions.width < 1420 ? "8px" : "25px",
                fontSize: "18px",
              }}
            >
              If you’re completing this form on behalf of a business,
              <br /> it must be completed by the business owner or
              <br /> someone with significant management responsibility
              <br /> of that business.
            </p>
            <div style={{ display: "flex", gap: 16, zIndex: 2 }}>
              <button
                type="submit"
                onClick={() => onSubmit("standard")}
                className="btn btn-primary mt-3 "
                style={{ width: 250 }}
              >
                Already have a Stripe account
              </button>
              <button
                type="submit"
                onClick={() => onSubmit("express")}
                className="btn btn-primary mt-3 "
                style={{ width: 250 }}
              >
                Create a new Stripe account
              </button>
            </div>
          </div>
          <img
            src={require("../../assets/images/leftStrap.png")}
            style={{
              width: 257,
              height: 180,
              position: "absolute",
              top: 13,
              left: -6,
            }}
          />
          <img
            src={require("../../assets/images/rightStrap.png")}
            style={{
              width: 400,
              height: 180,
              position: "absolute",
              right: -16,
              bottom: -30,
              zIndex: 0,
            }}
          />
        </div>
      </CardBody>
      <CardFooter style={{ backgroundColor: "#fff" }}>
        <div style={{ textAlign: "center" }}>
          Companies that trust Stripe Connect
        </div>
        <div
          className="row"
          style={{ justifyContent: "center", marginTop: -44 }}
        >
          <img
            src={require("../../assets/images/companyLogo1.png")}
            style={{
              width: 160,
              height: 160,
              objectFit: "contain",
            }}
          />
          <img
            src={require("../../assets/images/companyLogo2.png")}
            style={{
              width: 160,
              height: 160,
              objectFit: "contain",
            }}
          />
          <img
            src={require("../../assets/images/companyLogo3.png")}
            style={{
              width: 160,
              height: 160,
              objectFit: "contain",
            }}
          />
          <img
            src={require("../../assets/images/companyLogo4.png")}
            style={{
              width: 160,
              height: 160,
              objectFit: "contain",
            }}
          />
          <img
            src={require("../../assets/images/companyLogo5.png")}
            style={{
              width: 160,
              height: 160,
              objectFit: "contain",
            }}
          />
          <img
            src={require("../../assets/images/companyLogo6.png")}
            style={{
              width: 160,
              height: 160,
              objectFit: "contain",
            }}
          />
          <img
            src={require("../../assets/images/companyLogo7.png")}
            style={{
              width: 160,
              height: 160,
              objectFit: "contain",
            }}
          />
        </div>
      </CardFooter>
    </Card>
  );
};

export default BankingDetails;
